import * as fromDatatype from '../datatype-library';

export interface bl_inv_mst_category_level_setting_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    level_00_category_group_guid: fromDatatype.GuidDataFieldInterface;   
    level_01_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_01_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_01_mandatory: boolean;
    level_01_property_json: fromDatatype.JsonDatatypeInterface;
    level_02_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_02_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_02_mandatory: boolean;
    level_02_property_json: fromDatatype.JsonDatatypeInterface;
    level_03_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_03_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_03_mandatory: boolean;
    level_03_property_json: fromDatatype.JsonDatatypeInterface;
    level_04_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_04_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_04_mandatory: boolean;
    level_04_property_json: fromDatatype.JsonDatatypeInterface;
    level_05_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_05_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_05_mandatory: boolean;
    level_05_property_json: fromDatatype.JsonDatatypeInterface;
    level_06_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_06_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_06_mandatory: boolean;
    level_06_property_json: fromDatatype.JsonDatatypeInterface;
    level_07_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_07_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_07_mandatory: boolean;
    level_07_property_json: fromDatatype.JsonDatatypeInterface;
    level_08_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_08_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_08_mandatory: boolean;
    level_08_property_json: fromDatatype.JsonDatatypeInterface;
    level_09_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_09_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_09_mandatory: boolean;
    level_09_property_json: fromDatatype.JsonDatatypeInterface;
    level_10_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_10_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_10_mandatory: boolean;
    level_10_property_json: fromDatatype.JsonDatatypeInterface;
    level_11_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_11_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_11_mandatory: boolean;
    level_11_property_json: fromDatatype.JsonDatatypeInterface;
    level_12_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_12_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_12_mandatory: boolean;
    level_12_property_json: fromDatatype.JsonDatatypeInterface;
    level_13_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_13_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_13_mandatory: boolean;
    level_13_property_json: fromDatatype.JsonDatatypeInterface;
    level_14_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_14_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_14_mandatory: boolean;
    level_14_property_json: fromDatatype.JsonDatatypeInterface;
    level_15_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_15_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_15_mandatory: boolean;
    level_15_property_json: fromDatatype.JsonDatatypeInterface;
    level_16_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_16_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_16_mandatory: boolean;
    level_16_property_json: fromDatatype.JsonDatatypeInterface;
    level_17_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_17_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_17_mandatory: boolean;
    level_17_property_json: fromDatatype.JsonDatatypeInterface;
    level_18_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_18_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_18_mandatory: boolean;
    level_18_property_json: fromDatatype.JsonDatatypeInterface;
    level_19_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_19_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_19_mandatory: boolean;
    level_19_property_json: fromDatatype.JsonDatatypeInterface;
    level_20_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_20_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_20_mandatory: boolean;
    level_20_property_json: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date:fromDatatype.TimestampTzDatatypeInterface;
    status:fromDatatype.VarcharDatatypeInterface;
    revision:fromDatatype.GuidDataFieldInterface;
    vrsn:fromDatatype.VarcharDatatypeInterface;
}

export class bl_inv_mst_category_level_setting_hdr_RowClass implements bl_inv_mst_category_level_setting_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    level_00_category_group_guid: fromDatatype.GuidDataFieldInterface;   
    level_01_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_01_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_01_mandatory: boolean;
    level_01_property_json: fromDatatype.JsonDatatypeInterface;
    level_02_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_02_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_02_mandatory: boolean;
    level_02_property_json: fromDatatype.JsonDatatypeInterface;
    level_03_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_03_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_03_mandatory: boolean;
    level_03_property_json: fromDatatype.JsonDatatypeInterface;
    level_04_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_04_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_04_mandatory: boolean;
    level_04_property_json: fromDatatype.JsonDatatypeInterface;
    level_05_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_05_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_05_mandatory: boolean;
    level_05_property_json: fromDatatype.JsonDatatypeInterface;
    level_06_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_06_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_06_mandatory: boolean;
    level_06_property_json: fromDatatype.JsonDatatypeInterface;
    level_07_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_07_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_07_mandatory: boolean;
    level_07_property_json: fromDatatype.JsonDatatypeInterface;
    level_08_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_08_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_08_mandatory: boolean;
    level_08_property_json: fromDatatype.JsonDatatypeInterface;
    level_09_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_09_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_09_mandatory: boolean;
    level_09_property_json: fromDatatype.JsonDatatypeInterface;
    level_10_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_10_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_10_mandatory: boolean;
    level_10_property_json: fromDatatype.JsonDatatypeInterface;
    level_11_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_11_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_11_mandatory: boolean;
    level_11_property_json: fromDatatype.JsonDatatypeInterface;
    level_12_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_12_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_12_mandatory: boolean;
    level_12_property_json: fromDatatype.JsonDatatypeInterface;
    level_13_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_13_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_13_mandatory: boolean;
    level_13_property_json: fromDatatype.JsonDatatypeInterface;
    level_14_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_14_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_14_mandatory: boolean;
    level_14_property_json: fromDatatype.JsonDatatypeInterface;
    level_15_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_15_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_15_mandatory: boolean;
    level_15_property_json: fromDatatype.JsonDatatypeInterface;
    level_16_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_16_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_16_mandatory: boolean;
    level_16_property_json: fromDatatype.JsonDatatypeInterface;
    level_17_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_17_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_17_mandatory: boolean;
    level_17_property_json: fromDatatype.JsonDatatypeInterface;
    level_18_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_18_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_18_mandatory: boolean;
    level_18_property_json: fromDatatype.JsonDatatypeInterface;
    level_19_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_19_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_19_mandatory: boolean;
    level_19_property_json: fromDatatype.JsonDatatypeInterface;
    level_20_category_group_guid: fromDatatype.GuidDataFieldInterface;
    level_20_category_group_code: fromDatatype.VarcharDatatypeInterface;
    level_20_mandatory: boolean;
    level_20_property_json: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date:fromDatatype.TimestampTzDatatypeInterface;
    status:fromDatatype.VarcharDatatypeInterface;
    revision:fromDatatype.GuidDataFieldInterface;
    vrsn:fromDatatype.VarcharDatatypeInterface;
}
